import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  Container,
  Text,
  Center,
  Box,
  Anchor,
  Paper,
  Image,
} from '@mantine/core';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'stripe-pricing-table': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement> & {
          'pricing-table-id': string;
          'publishable-key': string;
        },
        HTMLElement
      >;
    }
  }
}

export function PricingPage() {
  useEffect(() => {
    // Load Stripe pricing table script
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v3/pricing-table.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      const existingScript = document.querySelector('script[src="https://js.stripe.com/v3/pricing-table.js"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <Box
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0b487c 0%, #1a6eb5 100%)',
        padding: '2rem 1rem',
      }}
    >
      <Container size="lg">
        <Center mb="xl">
          <Image src="/logo-inverse.png" alt="TrustPuma" h={80} w="auto" />
        </Center>

        <Paper withBorder shadow="xl" p="xl" radius="md" mb="xl">
          <stripe-pricing-table
            pricing-table-id="prctbl_1SjoHxBhAu40QCgghAsGN5GC"
            publishable-key="pk_live_51RA18uBhAu40QCggjFD1kY16tCL4S5MlQeQ9dl8YP2uJVBNp4XQ4w3dFktqbu8EXbZyKIWyTG2OZeestBf4X0g4X008jVen3Qr"
          />
        </Paper>

        <Text c="white" ta="center" size="sm" opacity={0.9}>
          Already have an account?{' '}
          <Anchor component={Link} to="/login" c="white" fw={600} underline="always">
            Sign in
          </Anchor>
        </Text>
      </Container>
    </Box>
  );
}
